import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import BlankLayout from '../../../../components/layout/BlankLayout';

export default (
  <Route key="/perfectbeauty/youcam/privacy-policy" element={<BlankLayout />}>
    <Route path="perfectbeauty/youcam/privacy-policy" element={<AsyncPage />} />
  </Route>
);
